'use client';

import { QueryClientProvider } from '@tanstack/react-query';
import dynamic from 'next/dynamic';
import { useState } from 'react';
import { makeQueryClient } from '@/lib/query-client';

// Opt-in: its floating button sits over the primary action of every side panel. Loaded only when
// opted in, so a build without the flag doesn't ship the devtools.
const showQueryDevtools = process.env.NEXT_PUBLIC_QUERY_DEVTOOLS === '1';
const ReactQueryDevtools = showQueryDevtools
  ? dynamic(() => import('@tanstack/react-query-devtools').then((module) => module.ReactQueryDevtools), { ssr: false })
  : null;

export function QueryProvider({ children }: { children: React.ReactNode }) {
  const [queryClient] = useState(makeQueryClient);

  return (
    <QueryClientProvider client={queryClient}>
      {children}
      {ReactQueryDevtools ? <ReactQueryDevtools initialIsOpen={false} /> : null}
    </QueryClientProvider>
  );
}
